import styled from "styled-components";

interface IBox {
	showBox?: boolean;
}

// TODO: Sanduba - Verificar essa parte
export const Container = styled.div.attrs<IBox>((props) => ({
	showBox: props.showBox ?? true,
}))`
	display: ${(props) => (props.showBox ? "block" : "none")};
	background: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 8px;
	width: 100%;
`;

export const Title = styled.h6`
	font-weight: bold;
	color: #000;
`;
